var exports = {
  "x": "xa15a2ab7--25893c--button",
  "e": "xa15a2ab7--25893c--button_active",
};

module.exports = exports;
